export default __webpack_public_path__ + "static/media/facebook_plain.0fb60a36.svg";